import { css } from 'linaria';

export const utpCardContent = css`
  padding: 24px;

  @media (--only-mobile) {
    width: 60%;
    padding: 16px;
  }
`;

export const wideDesktopUtpCardContent = css`
  @media (--only-desktop) {
    max-width: 308px;
    padding-right: 16px;
  }

  @media (--only-tablet) {
    max-width: 166px;
    padding-right: 16px;
  }
`;

export const wideTabletUtpCardContent = css`
  @media (--only-desktop) {
    max-width: 308px;
    padding-right: 16px;
  }

  @media (--only-tablet) {
    max-width: 166px;
    padding-right: 16px;
  }
`;

export const utpCardHeader = css`
  margin-bottom: 8px;

  @media (--from-tablet) {
    white-space: pre-line;
  }
`;

export const desktopCardText = css`
  @media (--to-desktop) {
    display: none;
  }
`;

export const mobileCardText = css`
  display: none;

  @media (--to-desktop) {
    display: block;
  }
`;

export const utpCardMedia = css`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 168px;
  height: 144px;
  border-radius: 0 0 var(--rounding-l) 0;

  @media (--only-mobile) {
    width: 120px;
    height: 102px;
  }
`;

export const wideDesktopCardMedia = css`
  @media (--only-desktop) {
    width: 152px;
    height: 130px;
  }

  @media (--only-tablet) {
    width: 152px;
    height: 130px;
  }
`;

export const wideTabletCardMedia = css`
  @media (--only-tablet) {
    width: 152px;
    height: 130px;
  }
`;
